import React from "react";
import "./UnderConstruction.css"

import logo from "../../../shared/images/under_construction.png"

const UnderConstruction = function () {
    return (
        <React.Fragment>
            <div className="page-body">
                <div className="page-content">
                    <div style={{ height: 400, padding: 40, justifyContent: "center", alignItems: "center", display: "flex", marginTop: '150px' }}>
                        <img src={logo} className="construction-logo" alt="under construction" />
                    </div>
                </div>
            </div>
        </React.Fragment >



    );
}

export default UnderConstruction;